import {ApiService} from "../index";
import {APIConfig} from "../../../constants";
import {LabRoleType} from "../../models/lab.model";

const EMERGENCY_PHONE_NUMBER = 911;
const weekDays = [
    {title: "Sunday", code: 'sunday'},
    {title: "Monday", code: 'monday'},
    {title: "Tuesday", code: 'tuesday'},
    {title: "Wednesday", code: 'wednesday'},
    {title: "Thursday", code: 'thursday'},
    {title: "Friday", code: 'friday'}
    , {title: "Saturday", code: 'saturday'}
]

const genderOptions = [{title: 'Male', code: 'male'}, {title: 'Female', code: 'female'}, {
    title: 'Other',
    code: 'other'
}];
const heightInFeet = [
    {title: '1 feet', code: '1'}, {title: '2 feet', code: '2'}, {title: '3 feet', code: '3'},
    {title: '4 feet', code: '4'}, {title: '5 feet', code: '5'}, {title: '6 feet', code: '6'},
    {title: '7 feet', code: '7'}, {title: '8 feet', code: '8'}
];

const heightInInches = [
    {title: '0 inch', code: '0'},
    {title: '1 inch', code: '1'},
    {title: '2 inches', code: '2'},
    {title: '3 inches', code: '3'},
    {title: '4 inches', code: '4'},
    {title: '5 inches', code: '5'},
    {title: '6 inches', code: '6'},
    {title: '7 inches', code: '7'},
    {title: '8 inches', code: '8'},
    {title: '9 inches', code: '9'},
    {title: '10 inches', code: '10'},
    {title: '11 inches', code: '11'}
];

const yesNoOptions = [{title: 'Yes', code: true}, {title: 'No', code: false}];
const insuranceTypes = [
    {title: "Professional", code: "professional"},
    {title: "Institutional", code: "institutional"}
]

const PhysicianMdOptions = [{title: 'MD', code: 'md'}, {title: 'Other', code: 'other'}];

const qrCodeType = [{title: 'Droid', code: 'droid'}, {title: 'Patient Registration', code: 'patientRegistration'}];

const selectFlow = [{title: 'FLow1', code: 'flow1'}, {title: 'FLow2', code: 'flow2'}];

const testResultingMode = [
    {title: 'Manual Upload/System Generated', code: 'manual upload'},
    {title: 'No Report', code: 'No Report'}
];

const reportingScheduleList = [
    {title: 'Everyday (24 hrs)', code: 'daily'},
    {title: 'Every Month (Month end date)', code: 'monthly'}
]

const orderTypes = [
    {title: 'Test', code: 'test'},
    {title: 'Test Panel', code: 'panel'}
]

const labType = [{title: 'In-house Lab', code: 'inHouseLab'}, {title: 'External Lab', code: 'externalLab'}];

const labRoles: { title: string, code: LabRoleType }[] = [
    {
        title: "Send Lab",
        code: "sendLab"
    },
    {
        title: "Receive Lab",
        code: "receiveLab"
    },
    {
        title: "Send & Receive Lab",
        code: "sendReceiveLab"
    }
];

// Barcode Label Printing
const LabelOptions = [
    {
        "title": "Standard (25.4mm x 50.8mm, 1\" x 2\")",
        "code": "standard"
    },
    // {
    //     "title": "Standard (25.4mm x 76.2mm, 1\" x 3\")",
    //     "code": "standard" //old
    // },
    {
        "title": "Small (12.7mm x 25.4mm, 0.5\" x 1\")",
        "code": "small"
    },
    {
        "title": "Large (50.8mm x 101.6mm, 2\" x 4\")",
        "code": "large"
    }
]

const LabelConfigurations: any = {
    small: {
        height: '12.7mm',
        width: '25.4mm',
        lineHeight: 1,
        fontSize: '7px',
        barcodeHeight: 30,
    },
    standard: {
        height: '25.4mm',
        width: '50.8mm',
        lineHeight: 1,
        fontSize: '10px',
        barcodeHeight: 60,
    },
    large: {
        height: '50.8mm',
        width: '101.6mm',
        lineHeight: 1.3,
        fontSize: '16px',
        barcodeHeight: 60,
    },
    // standard: {
    //     height: '25.4mm',
    //     width: '76.2mm',
    //     lineHeight: 1.2,
    //     fontSize: '10px',
    //     barcodeHeight: 30,
    // },
};


const getStatesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.STATE_LIST.METHOD](APIConfig.STATE_LIST.URL, payload);
}

const getCitiesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CITY_LIST.METHOD](APIConfig.CITY_LIST.URL, payload);
}
const getZipCodesist = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ZIPCODE_LIST.METHOD](APIConfig.ZIPCODE_LIST.URL, payload);
}

const getTimeZonesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TIMEZONE_LIST.METHOD](APIConfig.TIMEZONE_LIST.URL, payload);
}


const getTestPanelList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.STATIC_TEST_PANEL_LIST.METHOD](APIConfig.STATIC_TEST_PANEL_LIST.URL, payload);
}

const getTestPanelListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_LIST_LITE.METHOD](APIConfig.TEST_PANEL_LIST_LITE.URL, payload);
}

const getTestPanelBulkDetails = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_BULK_DETAILS.METHOD](APIConfig.TEST_PANEL_BULK_DETAILS.URL, payload);
}

const getPayorMixList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PAYOR_MIX_STATIC_LIST.METHOD](APIConfig.PAYOR_MIX_STATIC_LIST.URL, payload);
}
const getAccountPreferencesSettingsStaticData = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ACCOUNT_PREFERENCES_STATIC_DATA.METHOD](APIConfig.ACCOUNT_PREFERENCES_STATIC_DATA.URL, payload);
}

const getEthnicityList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.ETHNICITY_LIST.METHOD](APIConfig.ETHNICITY_LIST.URL, payload);
}

const getRaceList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.RACE_LIST.METHOD](APIConfig.RACE_LIST.URL, payload);
}

const getInsuranceCompanyList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.GET_INSURANCE_COMPANY_LIST.METHOD](APIConfig.GET_INSURANCE_COMPANY_LIST.URL, payload);
}

const getInsurancePlanList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.GET_INSURANCE_PLAN_LIST.METHOD](APIConfig.GET_INSURANCE_PLAN_LIST.URL, payload);
}

const getRelationshipList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.GET_RELATIONSHIP_LIST.METHOD](APIConfig.GET_RELATIONSHIP_LIST.URL, payload);
}

const getTestPanelResultingModeList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_RESULTING_MODE_LIST.METHOD](APIConfig.TEST_PANEL_RESULTING_MODE_LIST.URL, payload);
}

const getTestPanelDepartmentList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_DEPARTMENT_LIST.METHOD](APIConfig.TEST_PANEL_DEPARTMENT_LIST.URL, payload);
}

const getTestPanelAnalyzerList = (payload: any) => {
// @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_ANALYSER_LIST.METHOD](APIConfig.TEST_PANEL_ANALYSER_LIST.URL, payload);
}

const getTestPanelIntakeForm = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_TEST_PANEL_INTAKE_FORM.METHOD](APIConfig.GET_TEST_PANEL_INTAKE_FORM.URL(payload.testPanelCode), payload)
}
const getBillingModes = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BILLING_MODES_LIST.METHOD](APIConfig.BILLING_MODES_LIST.URL, payload)
}

const getFacilityTypesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_TYPES_LIST.METHOD](APIConfig.FACILITY_TYPES_LIST.URL, payload)
}

const getPrefixList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PREFIX_LIST.METHOD](APIConfig.GET_PREFIX_LIST.URL, payload)
}

const getSuffixList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SUFFIX_LIST.METHOD](APIConfig.GET_SUFFIX_LIST.URL, payload)
}

const getMaritalStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_MARITALSTATUS_LIST.METHOD](APIConfig.GET_MARITALSTATUS_LIST.URL, payload)
}

const getUserList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_LIST.METHOD](APIConfig.USER_LIST.URL, payload)
}

const getTestOrderStatus = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_ORDER_STATUS_LIST.METHOD](APIConfig.TEST_ORDER_STATUS_LIST.URL, payload)
}

const getTestPanelStatus = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_PANEL_STATUS_LIST.METHOD](APIConfig.TEST_PANEL_STATUS_LIST.URL, payload)
}

const getFacilityStatus = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.FACILITY_STATUS_LIST.METHOD](APIConfig.FACILITY_STATUS_LIST.URL, payload)
}

const getLocationStatus = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LOCATION_STATUS_LIST.METHOD](APIConfig.LOCATION_STATUS_LIST.URL, payload)
}

const getLabStatus = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.LAB_STATUS_LIST.METHOD](APIConfig.LAB_STATUS_LIST.URL, payload)
}

const getPhysicianListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PHYSICIAN_LIST_LITE.METHOD](APIConfig.PHYSICIAN_LIST_LITE.URL, payload)
}

const getCityListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.CITY_LIST_LITE.METHOD](APIConfig.CITY_LIST_LITE.URL, payload)
}

const getSampleStatusList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SAMPLE_STATUS_LIST.METHOD](APIConfig.SAMPLE_STATUS_LIST.URL, payload)
}

const getSampleTypesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SAMPLE_TYPES_LIST.METHOD](APIConfig.SAMPLE_TYPES_LIST.URL, payload)
}

const getPanelCodeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PANEL_CODE_LIST.METHOD](APIConfig.PANEL_CODE_LIST.URL, payload)
}

const getAccountExecutiveList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.USER_LIST.METHOD](APIConfig.USER_LIST.URL, payload)
}

const getEquipmentTypeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EQUIPMENT_TYPE_LIST.METHOD](APIConfig.EQUIPMENT_TYPE_LIST.URL, payload)
}
const downloadBulkTemplate = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.DOWNLOAD_TEMPLATE.METHOD](APIConfig.DOWNLOAD_TEMPLATE.URL, payload)
}
const getSampleCollectionDeviceList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.SAMPLE_COLLECTION_DEVICE_LIST.METHOD](APIConfig.SAMPLE_COLLECTION_DEVICE_LIST.URL, payload)
}

const getReportTypesList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.REPORT_TYPES_LIST.METHOD](APIConfig.REPORT_TYPES_LIST.URL, payload)
}

const getTestListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.TEST_LIST_LITE.METHOD](APIConfig.TEST_LIST_LITE.URL, payload)
}

const getExpressionsListLite = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.EXPRESSION_LIST_LITE.METHOD](APIConfig.EXPRESSION_LIST_LITE.URL, payload)
}

const getAgeList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.AGE_LIST.METHOD](APIConfig.AGE_LIST.URL, payload)
}

/**
 * Send isPhysicianRequired false to not get physician in the list.
 * @param payload
 */
const getRoleList = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.ROLE_LIST.METHOD](APIConfig.ROLE_LIST.URL, payload)
}
const getSystemConfig = () => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SYSTEM_CONFIG_DATA.METHOD](APIConfig.GET_SYSTEM_CONFIG_DATA.URL)
}
const getSampleTypeWithCollectionDevicesApi = () => {
    // @ts-ignore
    return ApiService[APIConfig.SAMPLE_TYPES_WITH_COLLECTION_DEVICES.METHOD](APIConfig.SAMPLE_TYPES_WITH_COLLECTION_DEVICES.URL)
}

const getModulePrimaryAttachment=()=>{
    // @ts-ignore
    return ApiService[APIConfig.GET_PRIMARY_SECTION_LIST.METHOD](APIConfig.GET_PRIMARY_SECTION_LIST.URL)
}

const StaticDataService = {
    weekDays,
    EMERGENCY_PHONE_NUMBER,
    getStatesList,
    getCitiesList,
    getZipCodesist,
    getTimeZonesList,
    getTestPanelList,
    getTestPanelListLite,
    getPayorMixList,
    getAccountPreferencesSettingsStaticData,
    getTestPanelBulkDetails,
    getEthnicityList,
    getRaceList,
    getInsuranceCompanyList,
    getInsurancePlanList,
    getRelationshipList,
    genderOptions,
    yesNoOptions,
    insuranceTypes,
    PhysicianMdOptions,
    heightInFeet,
    heightInInches,
    qrCodeType,
    labType,
    labRoles,
    selectFlow,
    testResultingMode,
    reportingScheduleList,
    orderTypes,
    LabelOptions,
    LabelConfigurations,

    getTestPanelResultingModeList,
    getTestPanelAnalyzerList,
    getTestPanelDepartmentList,
    getTestPanelIntakeForm,
    getBillingModes,
    getFacilityTypesList,
    getPrefixList,
    getSuffixList,
    getMaritalStatusList,
    getUserList,
    getTestOrderStatus,
    getTestPanelStatus,
    getFacilityStatus,
    getLocationStatus,
    getLabStatus,
    getPhysicianListLite,
    getCityListLite,
    getSampleStatusList,
    getSampleTypesList,
    getPanelCodeList,
    getAccountExecutiveList,
    getEquipmentTypeList,
    downloadBulkTemplate,
    getSampleCollectionDeviceList,
    getReportTypesList,
    getTestListLite,
    getExpressionsListLite,
    getAgeList,
    getRoleList,
    getSystemConfig,
    getSampleTypeWithCollectionDevicesApi,
    getModulePrimaryAttachment
}

export default StaticDataService;
